import React, { useState, useEffect, useCallback } from "react";
import Spinner from "react-bootstrap/Spinner";
import { Row, Col } from "react-bootstrap";
import Card from "../../../components/Card";
import { SettingsAPI } from "../../../js/api";
import { handleApiError } from "../../../js/helper/errorHandler";
import { toast } from "react-toastify";

const Settings = () => {
  const [form, setForm] = useState({
    making_charge: "",
    profit_margin: "",
    gold_price_threshold: "",
    etsy_charge: "",
    courier_charge: "",
    last_gold_price: "",
    labour_per_gram: "",
    auto_update_time: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  // Convert Array → Key-Value Map
  const normalizeSettings = (settingsArr) => {
    const map = {};
    settingsArr.forEach((s) => {
      map[s.key] = s.value;
    });
    return map;
  };

  const fetchSettings = useCallback(async () => {
    try {
      setIsLoading(true);

      const response = await SettingsAPI.get();

      if (response.data.status === 200) {
        const mapped = normalizeSettings(response.data.data.settings || []);
        setForm({
          making_charge: mapped.making_charge || "",
          profit_margin: mapped.profit_margin || "",
          gold_price_threshold: mapped.gold_price_threshold || "",
          last_gold_price: mapped.last_gold_price || "",
          etsy_charge: mapped.etsy_charge || "",
          courier_charge: mapped.courier_charge || "",
          labour_per_gram: mapped.labour_per_gram || "",
          auto_update_time: mapped.auto_update_time || "",
        });
      } else {
        handleApiError(response, "Fetching Settings");
      }
    } catch (error) {
      handleApiError(error, "Fetching Settings");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  const handleSave = async () => {
    try {
      setIsLoading(true);

      const payload = {
        settings: {
          making_charge: form.making_charge,
          profit_margin: form.profit_margin,
          gold_price_threshold: form.gold_price_threshold,
          etsy_charge: form.etsy_charge,
          courier_charge: form.courier_charge,
          labour_per_gram: form.labour_per_gram,
          auto_update_time: form.auto_update_time,
        },
      };

      const res = await SettingsAPI.update(payload);

      if (res.data.status === 200) {
        toast.success("Settings updated successfully!");
        fetchSettings();
      } else {
        handleApiError(res, "Updating settings");
      }
    } catch (error) {
      handleApiError(error, "Updating settings");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div>
        <Row>
          <Col sm="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">Pricing Settings</h4>
                </div>
              </Card.Header>

              <Card.Body className="px-4" style={{ position: "relative" }}>
                {isLoading && (
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                    }}
                  >
                    <Spinner animation="border" variant="primary" />
                  </div>
                )}

                {!isLoading && (
                  <form>
                    <Row>
                      {/* MAKING CHARGE */}
                      {/* <Col md={6} className="mb-3">
                        <label className="form-label">
                          Making Charge (₹ per gram)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          value={form.making_charge}
                          onChange={(e) =>
                            setForm({
                              ...form,
                              making_charge: e.target.value,
                            })
                          }
                        />
                      </Col> */}

                      {/* PROFIT MARGIN */}
                      {/* <Col md={6} className="mb-3">
                        <label className="form-label">Profit Margin (%)</label>
                        <input
                          type="number"
                          className="form-control"
                          value={form.profit_margin}
                          onChange={(e) =>
                            setForm({
                              ...form,
                              profit_margin: e.target.value,
                            })
                          }
                        />
                      </Col> */}

                      {/* GOLD PRICE THRESHOLD */}
                      <Col md={6} className="mb-3">
                        <label className="form-label">
                          Gold Price Update Threshold (₹)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          value={form.gold_price_threshold}
                          onChange={(e) =>
                            setForm({
                              ...form,
                              gold_price_threshold: e.target.value,
                            })
                          }
                        />
                      </Col>

                      <Col md={6} className="mb-3">
                        <label className="form-label">Courier Charge (₹)</label>
                        <input
                          type="number"
                          className="form-control"
                          value={form.courier_charge}
                          onChange={(e) =>
                            setForm({
                              ...form,
                              courier_charge: e.target.value,
                            })
                          }
                        />
                      </Col>

                      <Col md={6} className="mb-3">
                        <label className="form-label">ETSY CHARGE (%)</label>
                        <input
                          type="number"
                          className="form-control"
                          value={form.etsy_charge}
                          onChange={(e) =>
                            setForm({
                              ...form,
                              etsy_charge: e.target.value,
                            })
                          }
                        />
                      </Col>

                      {/* Labour CHARGE */}
                      <Col md={6} className="mb-3">
                        <label className="form-label">
                          Labour Charge (₹ per gram)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          value={form.labour_per_gram}
                          onChange={(e) =>
                            setForm({
                              ...form,
                              labour_per_gram: e.target.value,
                            })
                          }
                        />
                      </Col>

                      <Col md={6} className="mb-3">
                        <label className="form-label">
                          Auto Update Time (Daily)
                        </label>
                        <small className="text-muted mx-2">
                          Prices will sync automatically at this time.
                        </small>

                        <input
                          type="time"
                          className="form-control"
                          value={form.auto_update_time}
                          onChange={(e) =>
                            setForm({
                              ...form,
                              auto_update_time: e.target.value,
                            })
                          }
                        />
                      </Col>
                      {/* SAVE BUTTON */}
                      <Col md={12}>
                        <button
                          type="button"
                          className="btn btn-primary mt-3"
                          onClick={handleSave}
                        >
                          Save Settings
                        </button>
                      </Col>
                    </Row>
                  </form>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Settings;
